import {
    Card,
    Container,
    Table,
    TableContainer,
    TablePagination,
    InputAdornment,
		Typography,
} from '@mui/material';
import DataTableRow from '@src/components/data-table/data-row';
import TableHeader from '@src/components/data-table/header';
import Scrollbar from '@src/components/scrollbar';
import Iconify from '@src/components/iconify/Iconify';

import { TABLE_HEAD_PURCHASE_RECENT } from '@src/utils/mockdata/table-headers';

import { useSummaryService } from '../hooks';
import { usePurchasesContext } from '../../provider';
import TableRowItem from './table-row';
import { StyledRoot, StyledSearch } from "@src/sections/@dashboard/styles.css";
import { useAccessControlContext } from "@src/context/AccessControl";

const RecentTransactionTable = () => {
	const { data, recents, isLoading, isRefreshing } = useSummaryService();
	const { state, handlePageChange, handleRequestSort, handleRowsPerPageChange } = usePurchasesContext();
	console.log("recents", recents)
	return (
		<Container sx={{mt: 4}}>
			<Toolbar />
			<Card sx={{borderRadius: "25px", px: "23px", py: "10px"}}>
				<Scrollbar>
					<TableContainer sx={{ overflowX: 'auto' }}>
						<Table>
							<TableHeader
								order={state.order}
								orderBy={state.orderBy}
								headLabel={TABLE_HEAD_PURCHASE_RECENT}
								onRequestSort={handleRequestSort}
							/>
							<DataTableRow
								colSpan={9}
								isLoading={isLoading}
								isRefreshing={isRefreshing}
								headers={TABLE_HEAD_PURCHASE_RECENT}
								filterName={state.filterName}
								data={recents}
								renderItem={({ item, index }: any) => {
									return (
										<TableRowItem
											key={`${index}`}
											{...item}
										/>
									)
								}}
							/>
						</Table>
					</TableContainer>
				</Scrollbar>

				<TablePagination
					rowsPerPageOptions={[10, 25, 50]}
					page={(state.page || 0)}
					component="div"
					rowsPerPage={state.rowsPerPage || 10}
					count={data?.totalRecords ?? 0}
					onPageChange={handlePageChange}
					onRowsPerPageChange={handleRowsPerPageChange}
				/>
			</Card>
		</Container>
	)
}

const Toolbar = () => {
	useAccessControlContext();

	const { state, handleSearch } = usePurchasesContext();
	const { isLoading } = useSummaryService();
	const { search } = state || {};

	return (
		<StyledRoot sx={{
			width: "100%",
			my: {
				xl: 0,
				lg: 0,
				md: 0,
				sm: "22px",
				xs: "22px",
			},
			height: {
				xl: 96,
				lg: 96,
				md: 96,
				sm: 122,
				xs: 122,
			},
			flexDirection: {
				xl: "row",
				lg: "row",
				md: "row",
				sm: "column",
				xs: "column",
			},
			alignItems: {
				xl: 'center',
				lg: 'center',
				md: 'center',
				sm: 'flex-end',
				xs: 'flex-end',
			}
		}}>
			<Typography variant="h5" >
				Recent transactions table
			</Typography>
			<StyledSearch
				disabled={isLoading}
				value={search}
				sx={{
					width: {
						xl: 320,
						lg: 320,
						md: 320,
						sm: "100%",
						xs: "100%",
					},
					'&.Mui-focused': {
						width: {
							xl: 320,
							lg: 320,
							md: 320,
							sm: "100%",
							xs: "100%",
						}
					},
				}}
				onChange={(event) => handleSearch(event.target.value)}
				placeholder="Search"
				startAdornment={
					<InputAdornment position="start">
						<Iconify
							icon="eva:search-fill"
							sx={{
									color: 'text.disabled',
									width: 20,
									height: 20
							}}
						/>
					</InputAdornment>
				}
			/>
		</StyledRoot>
	)
}


export default RecentTransactionTable